import { createAction } from "redux-actions";
import { EntriesConstants } from "./entriesConstants";

export const fetchEntries = createAction(EntriesConstants.FETCH_ENTRIES);
export const exportsEntries = createAction(EntriesConstants.EXPORTS_ENTRIES);
export const fetchStatistics = createAction(EntriesConstants.FETCH_STATISTICS);
